import { EMAIL_REGEX_PATTERN } from "./isValidEmailPattern.constants";

const isValidEmailPattern = (value = "") => {
  return value !== "" && value.match(EMAIL_REGEX_PATTERN);
};

export default isValidEmailPattern;
